export const ExperienceArr = [
  [
    "2026 - Present",
    "Senior Software Developer",
    "Som Imaging Informatics Private Limited",
    "Onsite",
    "Kolkata, West Bengal, IN",
    "Performed backend development for promotional platforms using Yii, contributed to the development of AI agents using Python, and collaborated with international teams to deliver scalable and maintainable applications.",
  ],
  [
    "2024 - 2026",
    "Senior Backend Engineer",
    "Minerva Infotech Private Limited",
    "Hybrid",
    "Kolkata, West Bengal, IN",
    "Led backend development using Symfony and contributed to frontend solutions with React Native and Next.js. Collaborated with international teams to deliver scalable and maintainable applications.",
  ],
  [
    "2023 - 2024",
    "Senior Lead Developer",
    "Seekex Technologies Private Limited",
    "Remote",
    "Ludhiana, Punjab, IN",
    "Spearheaded the development and modernization of ERP systems using Laravel and CakePHP. Led technical initiatives, collaborated with business stakeholders, and delivered scalable solutions that improved operational efficiency while maintaining high standards of code quality and system reliability.",
  ],
  [
    "2021 - 2023",
    "Senior Software Engineer",
    "BCG Attorney Search Private Limited",
    "Remote",
    "Ahmedabad, Gujrat, IN",
    "Developed and maintained core features for a large-scale legal platform, focusing on backend architecture, performance optimization, and system reliability. Worked closely with product and business teams to deliver efficient solutions aligned with legal industry requirements.",
  ],
  [
    "2019 - 2021",
    "Senior Developer & Co-Lead",
    "Lee & Nee Software Exports Limited",
    "Onsite",
    "Kolkata, West Bengal, IN",
    "Played a key leadership role in the development of educational ERP systems, driving architectural improvements and feature delivery. Collaborated with cross-functional teams to build scalable solutions that streamlined academic and administrative operations.",
  ],
  [
    "2019",
    "Senior Developer",
    "Tootle Softwares Private Limited",
    "Onsite",
    "Kolkata, West Bengal, IN",
    "Engineered diverse web solutions using CodeIgniter and Laravel, including a customizable T-shirt eCommerce platform with Fabric.js-powered live design previews. Successfully delivered gaming platforms and a digital music marketplace, emphasizing performance, scalability, and user-centric experiences.",
  ],
  [
    "2016 - 2019",
    "Team Leader",
    "SB3 Software Solutions Private Limited",
    "Onsite",
    "Kolkata, West Bengal, IN",
    "Managed end-to-end development of CodeIgniter projects, leading a team of developers and collaborating closely with clients. Drove project planning, technical execution, and team growth while ensuring timely delivery and high-quality software solutions.",
  ],
  [
    "2014 - 2016",
    "Development Team Lead",
    "Sketch Web Solutions",
    "Onsite",
    "Kolkata, West Bengal, IN",
    "Supervised the development lifecycle of web applications using CodeIgniter, from requirement analysis to deployment. Collaborated with clients and development teams to deliver reliable, business-focused solutions while maintaining code quality standards.",
  ],
  [
    "2012 - 2014",
    "Senior Developer",
    "Esolz Technologies Private Limited",
    "Onsite",
    "Kolkata, West Bengal, IN",
    "Developed scalable web applications using Core PHP and CodeIgniter while collaborating directly with clients to understand business requirements. Contributed to project planning, supported junior developers, and helped deliver reliable solutions aligned with client expectations.",
  ],
];
